import { useEffect } from "react";
import styles from "./documentation.module.scss";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import ProfileCard from "../../../components/ProfileCard";
import { useProfileRole } from "../../../helpers/hooks";
import { DocumentationProps } from "../../../interfaces/profile";

const Documentation = ({
    user
}: DocumentationProps) => {
    const location = useLocation();
    const navigate = useNavigate();
    const profileRole = useProfileRole();

    useEffect(() => {
        if(location.pathname === "/profile/documentation"){
            if(profileRole(user?.profile?.code) === "admin"){
                navigate("signers");
            }else{
                navigate("/profile/dashboard");
            }
        }
    },[location])

    return (
        <ProfileCard className={styles.profileCardDocumentation}>
            <div className={styles.documentationContainer}>
                <Outlet/>
            </div>
        </ProfileCard>
    )
};
export default Documentation;